import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ContentSimpleCard from '../components';

function mapStateToProps(state) {
  return {
    actualUser: state.session.user,
    literals: state.i18n.literals.themeTableDetail,
    app: state.app,
  };
}

function mapDispatchToProps() {
  return {
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ContentSimpleCard));



// WEBPACK FOOTER //
// ./src/components/Cards/ContentSimpleCard/container/index.js